// src/components/QuoteForm.jsx
import React, { useState } from 'react';
import { sendQuoteEmail } from '../scripts/email';

const QuoteForm = ({ mode = 'full' }) => {
    const [submitted, setSubmitted] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState('');

    const isCompact = mode === 'compact';

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError('');
        setSubmitted(false);
        setSubmitting(true);

        const form = event.target;
        const formData = new FormData(form);
        const values = Object.fromEntries(formData.entries());

        // Normalize service type values for nicer emails
        const serviceTypeMap = {
            home: 'Home',
            office: 'Office',
            rentals: 'Rentals / Move-in / Move-out',
        };

        const normalizedValues = {
            ...values,
            serviceType: serviceTypeMap[values.serviceType] || values.serviceType,
        };

        try {
            await sendQuoteEmail(normalizedValues, {
                source: mode === 'full' ? 'Quote Page' : 'Home Quote Teaser',
            });

            setSubmitted(true);
            form.reset();
        } catch (err) {
            console.error('Quote request failed:', err);
            setError(
                'Something went wrong sending your request. Please try again, or call +1 519-731-8214.'
            );
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="quote-form">
            <form onSubmit={handleSubmit}>
                <div className="quote-form__grid">
                    <div className="form-field">
                        <label htmlFor={`name-${mode}`}>Name*</label>
                        <input
                            id={`name-${mode}`}
                            name="name"
                            type="text"
                            placeholder="Your full name"
                            required
                        />
                    </div>
                    <div className="form-field">
                        <label htmlFor={`email-${mode}`}>Email*</label>
                        <input
                            id={`email-${mode}`}
                            name="email"
                            type="email"
                            placeholder="you@example.com"
                            required
                        />
                    </div>
                    <div className="form-field">
                        <label htmlFor={`phone-${mode}`}>Phone*</label>
                        <input
                            id={`phone-${mode}`}
                            name="phone"
                            type="tel"
                            placeholder="+1 519-731-8214"
                            required
                        />
                    </div>
                    <div className="form-field">
                        <label htmlFor={`serviceType-${mode}`}>Service type*</label>
                        <select id={`serviceType-${mode}`} name="serviceType" required>
                            <option value="">Select a service</option>
                            <option value="home">Home</option>
                            <option value="office">Office</option>
                            <option value="rentals">Rentals / Move-in / Move-out</option>
                        </select>
                    </div>
                    <div className="form-field">
                        <label htmlFor={`city-${mode}`}>City*</label>
                        <select id={`city-${mode}`} name="city" required>
                            <option value="">Select a city</option>
                            <option value="Guelph">Guelph</option>
                            <option value="Kitchener">Kitchener</option>
                            <option value="Waterloo">Waterloo</option>
                            <option value="Cambridge">Cambridge</option>
                            <option value="Other">Other</option>
                        </select>
                    </div>

                    {!isCompact && (
                        <>
                            <div className="form-field">
                                <label htmlFor={`propertyType-${mode}`}>Property type</label>
                                <input
                                    id={`propertyType-${mode}`}
                                    name="propertyType"
                                    type="text"
                                    placeholder="House, apartment, office, etc."
                                />
                            </div>
                            <div className="form-field">
                                <label htmlFor={`size-${mode}`}>Size</label>
                                <input
                                    id={`size-${mode}`}
                                    name="size"
                                    type="text"
                                    placeholder="Approx. sq ft or bedrooms/bathrooms"
                                />
                            </div>
                            <div className="form-field">
                                <label htmlFor={`frequency-${mode}`}>Cleaning frequency</label>
                                <select id={`frequency-${mode}`} name="frequency">
                                    <option value="">Select frequency</option>
                                    <option value="one-time">One-time</option>
                                    <option value="weekly">Weekly</option>
                                    <option value="bi-weekly">Bi-weekly</option>
                                    <option value="monthly">Monthly</option>
                                    <option value="not-sure">Not sure yet</option>
                                </select>
                            </div>
                            <div className="form-field">
                                <label htmlFor={`preferredDate-${mode}`}>Preferred date / time</label>
                                <input
                                    id={`preferredDate-${mode}`}
                                    name="preferredDate"
                                    type="text"
                                    placeholder="e.g. Weekdays after 5pm"
                                />
                            </div>
                        </>
                    )}
                </div>

                <div className="form-field form-field--full">
                    <label htmlFor={`message-${mode}`}>
                        {isCompact ? 'Tell us a bit about your space' : 'Anything else we should know?'}
                    </label>
                    <textarea
                        id={`message-${mode}`}
                        name="message"
                        rows={isCompact ? 3 : 4}
                        placeholder={
                            isCompact
                                ? 'Number of rooms, special requests, pets, etc.'
                                : 'Details about rooms, flooring, pets, or special requests help us send an accurate quote.'
                        }
                    />
                </div>

                {!isCompact && (
                    <div className="form-field form-field--full">
                        <label htmlFor={`referral-${mode}`}>How did you hear about us?</label>
                        <input
                            id={`referral-${mode}`}
                            name="referral"
                            type="text"
                            placeholder="Friend, Google, social media, etc."
                        />
                    </div>
                )}

                <button
                    type="submit"
                    className="btn btn-primary quote-form__submit"
                    disabled={submitting}
                >
                    {submitting ? 'Sending…' : 'Submit Quote Request'}
                </button>
            </form>

            <p className="quote-form__note">
                No obligation. We’ll review your details and respond as soon as possible.
            </p>

            {error && <div className="quote-form__error">{error}</div>}

            {submitted && (
                <div className="quote-form__success">
                    Thank you! Your request has been sent to Murtaza. We’ll get back to you as soon as
                    possible.
                </div>
            )}
        </div>
    );
};

export default QuoteForm;
